var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54 3.867c1.72-1.72 3.79-2.578 6.21-2.578s4.48.86 6.172 2.578C17.64 5.56 18.5 7.617 18.5 10.04s-.86 4.492-2.578 6.21c-1.693 1.693-3.75 2.54-6.172 2.54s-4.492-.846-6.21-2.54C1.846 14.53 1 12.46 1 10.04s.846-4.48 2.54-6.172zm10.43 9.102l-2.93-2.93 2.97-2.93c.156-.156.156-.312 0-.47l-.86-.82c-.078-.078-.156-.117-.234-.117-.052 0-.117.04-.195.117L9.75 8.71 6.78 5.82c-.078-.078-.143-.117-.195-.117-.078 0-.156.04-.234.117l-.82.82a.29.29 0 000 .469l2.97 2.93-2.97 2.97c-.052.026-.078.09-.078.195s.026.182.078.234l.82.86c.052.052.13.078.234.078s.182-.026.234-.078l2.93-2.97 2.97 2.93c.078.078.143.117.195.117.078 0 .156-.04.234-.117l.82-.82a.262.262 0 00.117-.234c0-.078-.04-.156-.117-.234z"
  })));
}

export default SvgClearIcon;